import { areaCanonicalUrl, AreaInfo, cleanListingPath } from './areaPages';

type Args = { asPath: string; area?: AreaInfo; apiCanonical?: string | null };

const ORIGIN = 'https://www.paziresh24.com';
/**
 * `/s/<city>/exp-<specialty>/` — a single-specialty listing (city may be `ir`). The city part is any segment: 67 city
 * slugs are non-ASCII and reach the server percent-encoded (`/s/esfar%C4%81yen/…`); exp slugs are all ASCII.
 */
const EXP_LISTING_PATH = /^\/s\/[^/]+\/(exp-[a-z0-9-]+)\/$/;

/**
 * The canonical of a `/s/*` listing; undefined ⇒ the Seo component's fallback (the clean path, no query).
 *
 * The search API only sends `seo.canonical_link` where someone typed one into the CMS (Strapi
 * `search_landings_customize`) — today the all-Iran group consult landings, e.g. `/s/ir/dermatology/?turn_type=consult`.
 * Specialty (`exp-`) consult pages get null, so the fallback pointed them at the in-person page and no online-visit
 * specialty page could rank (owner decision 2026-10-31). The all-Iran one is its own canonical, with `turn_type=consult`
 * and nothing else, exactly like the group consult pages. A city's online page lists the same doctors (online search is
 * nationwide: Iran, Tehran and Isfahan gave the same 507 for women's health, 2026-10-31), so it points to the all-Iran
 * one rather than claim ~12k near-duplicates as canonical (review 2026-10-31; online queries with a city name are small
 * and Google already serves the all-Iran page for them: «ویزیت آنلاین دکتر زنان تهران» 218 impressions in Oct).
 */
export const listingCanonicalUrl = ({ asPath, area, apiCanonical }: Args): string | undefined => {
  if (area) return areaCanonicalUrl(asPath);
  if (apiCanonical) return apiCanonical;

  const path = cleanListingPath(asPath);
  const turnType = new URLSearchParams(asPath.split('#')[0].split('?')[1] ?? '').get('turn_type');
  const exp = turnType === 'consult' ? path.match(EXP_LISTING_PATH) : null;
  if (exp) return `${ORIGIN}/s/ir/${exp[1]}/?turn_type=consult`;

  return undefined;
};
